import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';

import { QUERY } from '../../gql-operations';
import PublishedPageLayout from './PublishedPageLayout';
import SharedMessageContent from '../../components/Sharing/SharedMessageContent';
import { WHITE, PALE_WHITE_6 } from '../../appearance/Colors';

const PublishedMessagePage = props => {
    const { t: lnT } = useTranslation();
    const token = props.match.params.token;

    const { data, loading, error } = useQuery(QUERY.GET_PUBLISHED_MESSAGE, {
        variables: { data: { token } },
        skip: !token,
        fetchPolicy: 'network-only'
    });

    const message = data?.getPublishedMessage;

    useEffect(() => {
        if (message?.title) {
            document.title = `${message.title} — Luckynote`;
        }
    }, [message]);

    if (loading) {
        return (
            <PublishedPageLayout>
                <Page>
                    <StateMessage>{lnT('common:loading')}</StateMessage>
                </Page>
            </PublishedPageLayout>
        );
    }

    if (error || !message) {
        return (
            <PublishedPageLayout>
                <Page>
                    <StateMessage>{lnT('messages:sharedMessageUnavailable')}</StateMessage>
                </Page>
            </PublishedPageLayout>
        );
    }

    return (
        <PublishedPageLayout>
            <Page>
                <SharedMessageContent message={message} />
            </Page>
        </PublishedPageLayout>
    );
};

const Page = styled.div`
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 20px 80px;
    color: ${WHITE};
`;

const StateMessage = styled.div`
    color: ${PALE_WHITE_6};
    text-align: center;
    padding: 80px 0;
`;



export default PublishedMessagePage;
